import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {parseOptions} from '../question-helper';

@Component({
    selector: 'app-question-percentage-variation-one',
    templateUrl: './question-percentage-variation-one.component.html',
    styleUrls: ['./question-percentage-variation-one.component.scss'],
    standalone: false
})
export class QuestionPercentageVariationOneComponent implements OnInit {

  @Input() footerLabelText = 'Total';
  @Input() percentAmount = 100;
  @Input() question: Question;
  @Output() questionAnswer = new EventEmitter<any>();

  items: any[] = [];

  constructor() { }

  ngOnInit(): void {
    if (this.question?.options?.length) {
      const options = parseOptions(this.question.options);
      if (options?.length) {
        options.sort((a, b) => a.answer_order > b.answer_order ? 1 : a.answer_order < b.answer_order ? -1 : 0);
        for (const o of options) {
          this.items.push({answer: o.answer, percent: ''});
        }
      }
    } else {
      this.items = [{answer: 'Item 1', percent: ''}, {answer: 'Item 2', percent: ''}];
    }
  }

  onChange(): void {
    console.log('valid', this.items.every(item => item.percent));
    if (this.items.every(item => item.percent) && this.question && (this.totalAmount === this.percentAmount)) {
      const value = this.items.map(i => i.percent).join('|');
      console.log('value', value);
      this.question.answer = value;
      this.questionAnswer.emit(this.question);
    }
  }

  get totalAmount(): number {
    let total = 0;
    for (const a of this.items) {
      total += +a.percent;
    }
    return total;
  }

}
